export default __webpack_public_path__ + "static/media/python.063da199.svg";